import '../css/OrderHistory.css'
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import SessionAlert from '../components/SessionAlert';
import CircularIndeterminate from '../components/CircularLoad';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { responseArray, authHeaders } from '../utils/apiFetch';

export default function OrderHistory(){
    const [orders, setOrders] = useState(null);

    useEffect(() => {
        fetchOrderHistory();
    }, []);
    
    const fetchOrderHistory = async () => {
        try {
          const response = await fetch('/api/user/orders', {
              headers: authHeaders()
          });
          if (response.ok) {
            const data = await response.json();
            setOrders(responseArray(data, 'orders'));
          } else {
            console.error('Failed to fetch products');
            setOrders([]);
          }
        } catch (error) {
          console.error('Error:', error);
          setOrders([]);
        }
    };

    if (orders === null) {
        return (
            <div className="order-history-loading">
                <CircularIndeterminate display={true}/>
            </div>
        )
    }

    if(orders.length === 0) {
        return (
            <div className="order-history-empty">
                <div className="order-empty-icon">
                    <ReceiptLongIcon />
                </div>
                <h2>No orders yet</h2>
                <p>Your completed orders will appear here once you check out.</p>
                <Link to='/' className="order-history-primary">Start shopping</Link>
            </div>
        )
    }

    const formatDate = (value) => {
        if (!value) return 'Unknown date';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return 'Unknown date';
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    return (
        <main className="order-history-page">
            <SessionAlert/>
            <header className="order-history-header">
                <div className="order-history-title">
                    <span className="order-history-icon">
                        <ReceiptLongIcon />
                    </span>
                    <div>
                        <h1>Order history</h1>
                        <p>{orders.length} {orders.length === 1 ? 'order' : 'orders'} placed from your account.</p>
                    </div>
                </div>
                <Link to="/" className="order-history-secondary">Continue shopping</Link>
            </header>

            <div className="order-history-list">
                {orders.map((order) => (
                    <article className="order-card" id={`order-${order._id}`} key={`order-${order._id}`}>
                        <div className="order-card-main">
                            <div>
                                <span className="order-label">Order number</span>
                                <h2>#{order.number}</h2>
                            </div>
                            <span className="order-status">{order.status || 'Pending'}</span>
                        </div>

                        <div className="order-card-meta">
                            <CalendarTodayIcon fontSize="small" />
                            <span>Ordered {formatDate(order.date)}</span>
                        </div>

                        <Link to={`/order/${order.number}`} className="order-card-action">
                            View details
                            <ArrowForwardIcon fontSize="small" />
                        </Link>
                    </article>
                ))}
            </div>
        </main>
    )
}
